import { FC } from 'react';

import Table from 'modules/_shared/Table';

import OperationDetailsTableHeader from './OperationDetailsTableHeader';
import OperationDetailsTableBody from './OperationDetailsTableBody';
import OperationDetailsTableFooter from './OperationDetailsTableFooter';

const OperationDetailsTable: FC = () => {
  const tableContent = (
    <>
      <OperationDetailsTableHeader />
      <OperationDetailsTableBody />
      <OperationDetailsTableFooter />
    </>
  );

  return <Table content={tableContent} />;
};

export default OperationDetailsTable;
